module.exports = __webpack_public_path__ + "img/tutorial_five_fr.ba557bbd.png";